import React from 'react';
import $ from 'jquery';
import { renderList, columnWidth } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { withReferer } from 'plugins/contextual-back';

export function list(ctx) {
  const customer = ctx.params.id;
  const referer = `/pco-manager/customers/${customer}/users`;

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/customer/users/${id}`, referer);
  const loadNextUrl = `/pco-manager/customers/${customer}/users/range.json`;

  renderList(rowClickedUrl, loadNextUrl, renderColumns);
}

export function create() {
  edit();
}

function handleAddressVisibility() {
  const changeVisibility = () => {
    if (
      $('input[name=has_own_address]') &&
      ($('input[name=has_own_address]')
        .parent()
        .checkbox('is checked') ||
        $('input[name=has_own_address]').val() === 'true')
    ) {
      $('div.address').show();
    } else {
      $('div.address').hide();
    }
  };

  changeVisibility();

  $('input[name=has_own_address]')
    .parent()
    .checkbox({
      onChecked: function() {
        changeVisibility();
      },
      onUnchecked: function() {
        changeVisibility();
      },
    });
}

function handleRestrictionsVisibility() {
  const hasRestriction = $('input[name=has_restriction]').parent();

  const showRestrictions = () => $('div.restrictions').show();
  const hideRestrictions = () => $('div.restrictions').hide();

  if (hasRestriction.checkbox('is checked')) {
    showRestrictions();
  } else {
    hideRestrictions();
  }

  hasRestriction.checkbox({
    onChecked: function() {
      showRestrictions();
    },
    onUnchecked: function() {
      hideRestrictions();
    },
  });
}

function handleIsContact() {
  const isPrincipal = $('input[name=is_principal]').parent();
  const usableAsContact = $('input[name=is_usable_as_contact_site]').parent();

  const changeRequirements = () => {
    if (
      isPrincipal.checkbox('is checked') ||
      usableAsContact.checkbox('is checked')
    ) {
      $('input[name=first_name]')
        .parent()
        .addClass('required');
      $('input[name=phone]')
        .parent()
        .addClass('required');
    } else {
      $('input[name=first_name]')
        .parent()
        .removeClass('required');
      $('input[name=phone]')
        .parent()
        .removeClass('required');
    }
  };

  const eventsHandling = {
    onChecked: function() {
      changeRequirements();
    },
    onUnchecked: function() {
      changeRequirements();
    },
  };

  isPrincipal.checkbox(eventsHandling);
  usableAsContact.checkbox(eventsHandling);

  changeRequirements();
  if (isPrincipal.checkbox('is checked')) {
    isPrincipal.addClass('read-only');
    isPrincipal.attr('title', 'Ne peut être désactivé');
  }
}

function handleHasAccess() {
  const setEmailRequired = () => {
    $('#email')
      .parent()
      .addClass('required');
  };
  const setEmailNotRequired = () => {
    $('#email')
      .parent()
      .removeClass('required');
  };

  const invoiceCheck = $('input[name=invoice_allowed]').parent();
  const reportCheck = $('input[name=report_allowed]').parent();
  const caseDocCheck = $('input[name=document_allowed]').parent();

  const modifyEmailRequirement = () => {
    if (
      invoiceCheck.checkbox('is checked') ||
      reportCheck.checkbox('is checked') ||
      caseDocCheck.checkbox('is checked')
    ) {
      setEmailRequired();
    } else {
      setEmailNotRequired();
    }
  };

  modifyEmailRequirement();

  const eventHandling = {
    onChecked: function() {
      modifyEmailRequirement();
    },
    onUnchecked: function() {
      modifyEmailRequirement();
    },
  };

  invoiceCheck.checkbox(eventHandling);
  reportCheck.checkbox(eventHandling);
  caseDocCheck.checkbox(eventHandling);
}

export function edit() {
  handleRestrictionsVisibility();
  handleIsContact();
  handleHasAccess();
  handleAddressVisibility();
}

function invoiceAccessRenderer({ cellData, rowData }) {
  if (!cellData) {
    return <div className="ui horizontal red label">Non</div>;
  } else if (rowData.all_cases) {
    return <div className="ui horizontal green label">Tous</div>;
  } else {
    return <div className="ui horizontal orange label">Limité</div>;
  }
}

function interventionAccessRenderer({ cellData, rowData }) {
  if (!cellData) {
    return <div className="ui horizontal red label">Non</div>;
  } else if (rowData.all_sites && rowData.all_cases) {
    return <div className="ui horizontal green label">Tous</div>;
  } else {
    return <div className="ui horizontal orange label">Limité</div>;
  }
}

function contractAccessRenderer({ cellData, rowData }) {
  if (!cellData) {
    return <div className="ui horizontal red label">Non</div>;
  } else if (rowData.all_sites && rowData.all_cases) {
    return <div className="ui horizontal green label">Tous</div>;
  } else {
    return <div className="ui horizontal orange label">Limité</div>;
  }
}

function isPrincipalRenderer({ cellData }) {
  if (cellData) {
    return (
      <div>
        {' '}
        <i className="check icon"> </i>{' '}
      </div>
    );
  } else {
    return <div> </div>;
  }
}

function renderColumns(width) {
  return [
    <Column
      key="last_name"
      dataKey="last_name"
      width={columnWidth(width, 3)}
      label="Nom"
    />,
    <Column
      key="first_name"
      dataKey="first_name"
      width={columnWidth(width, 2.5)}
      label="Prénom"
    />,
    <Column
      key="email"
      dataKey="email"
      width={columnWidth(width, 3)}
      label="Email"
    />,
    <Column
      key="is_principal"
      dataKey="is_principal"
      width={columnWidth(width, 2)}
      label="Contact principal"
      cellRenderer={isPrincipalRenderer}
    />,
    <Column
      key="invoice_access_allowed"
      dataKey="invoice_access_allowed"
      width={columnWidth(width, 2)}
      label="Facturation"
      cellRenderer={invoiceAccessRenderer}
    />,
    <Column
      key="report_access_allowed"
      dataKey="report_access_allowed"
      width={columnWidth(width, 2)}
      label="Compte rendu"
      cellRenderer={interventionAccessRenderer}
    />,
    <Column
      key="document_access_allowed"
      dataKey="document_access_allowed"
      width={columnWidth(width, 2.5)}
      label="Documents du contrat"
      cellRenderer={contractAccessRenderer}
    />,
  ];
}



// WEBPACK FOOTER //
// ./src/modules/saas/customers/users/index.js